<template>
	<page-container :page="page">
		<div v-if="page.embedCode" class="video-container">
			<div class="video-object">
				<iframe
					:src="`${page.embedCode}?background=1&autoplay=1&loop=1&muted=1`"
					frameborder="0"
					allow="autoplay; fullscreen; picture-in-picture"
					allowfullscreen
					title="Hotel Wesseling video"
				/>
			</div>
		</div>
		<heading-image
			v-else-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<main-content :title="page.title || page.header" :subtitle="page.subtitle" :content="page.content" />

		<contentblocks :items="page.contentblocks" />
		<frequently-asked-questions
			v-if="page.frequentlyAskedQuestion"
			:items="page.frequentlyAskedQuestion.faqitems"
			:header="page.frequentlyAskedQuestion.header"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();

await fetchPage();
</script>

<style lang="scss" scoped>
section {
	padding: 50px 0 20px;
}

.main-content.contentblocks {
	padding-top: 20px !important;
}

.video-container {
	width: 100%;
	height: 75vh;
	position: relative;
	margin-top: -130px;
	overflow: hidden;

	&::before {
		content: '';
		display: block;
		inset: 0;
		background: rgb(0 0 0 / 0%);
		position: absolute;
		z-index: 2;
	}

	.video-object {
		object-fit: cover;
		width: 150%;
		height: 150%;
	}

	iframe {
		position: absolute;
		inset: 0;
		width: 160%;
		height: 155%;
		margin-left: -30%;
		margin-top: -100px;
		z-index: 1;
	}
}

@media (max-width: 700px) {
	.video-container {
		height: 320px;
		margin-top: -50px;

		iframe {
			margin-top: -50px;
		}
	}
}
</style>
